module.exports = __webpack_public_path__ + "img/Allegiant-Stadium-BG.14d41598.jpg";